export const DELIVERY_TIME = 'delivery_time';
export const GLOVES = 'GlovesRecommendedUses';
export const COLLECTION_LINE = 'Kollektionslinie';
export const SIZE = 'size';
export const COLOUR = 'hue';
export const GENDER = 'gender';
